// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CustomPropertyType } from './custom-property-type';
import { MergeTemplateReplaceField } from './merge-template-replace-field';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReplaceField extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  replaceFieldId!: number;
  category?: string;
  createdBy!: string;
  createdDate!: Date;
  customPropertyTypeId?: number;
  locationId!: number;
  replaceFieldCode!: string;
  replaceFieldDataType!: string;
  replaceFieldFormat!: string;
  replaceFieldSqlstring?: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  wizardDisplayText!: string;
  customPropertyType!: CustomPropertyType;
  mergeTemplateReplaceFields!: MergeTemplateReplaceField[];
}

